import { render } from "./OrgProfile.vue?vue&type=template&id=783d2aa4&scoped=true"
import script from "./OrgProfile.vue?vue&type=script&lang=js"
export * from "./OrgProfile.vue?vue&type=script&lang=js"

import "./OrgProfile.vue?vue&type=style&index=0&id=783d2aa4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783d2aa4"]])

export default __exports__